<template>
  <div>
    <modal :show.sync="modals.submit" style="z-index: 99999;" class="modal-eprf" centered>
      <div class="row">
        <div class="col-lg text-center">
          <img src="@/assets/img/tick.png" width="300" />
          <br />
          <br />
          <br />
          <h1>QUOTATION ACCEPTED</h1>
          <p>
            Our Customer Relations Officer will be in touch with you within 24
            hours
          </p>
        </div>
      </div>
    </modal>
    <modal :show.sync="modals.uploaddoc" class="modal-eprf" centered>
      <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
        header="UPLOAD PO / QUOTATION ACCEPTANCE" header-bg-variant="primary" header-text-variant="white">
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">UPLOAD PO / QUOTATION ACCEPTANCE</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  " class="tim-icons icon-simple-remove" @click="modals.uploaddoc = false"></i>
              </base-button>
            </div>
          </div>
        </template>

        <div class="row">
          <div class="col-lg-1">
            <div class="fileinput">
              <label style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                " for="quo-upload" type="primary" class="btn">
                Upload
              </label>

              <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="quo-upload" ref="quo" type="file" name="..." class="valid"
                :multiple="true" aria-invalid="false" style="display: none" v-on:change="onFileChangeQuo" />
            </div>
          </div>

          <div class="col-lg text-left">
          </div>
          <div class="col-lg-4 text-right">
            <base-button type="primary" @click="getApprove()" :disabled="cansubmit">Submit</base-button>
          </div>
        </div>

        <div class="col-lg">
          <div v-for="(item, index) in allquodocname" :key="index">
            <div class="row">
              <p style="color: #A5A5A5;">{{ item.filename }}</p>
              <i style="
                    color: #FF0000;
                    font-weight: 900;
                    font-size: 20px;
                    margin-left: 10px;
                    margin-top: 20px;
                  " class="tim-icons icon-simple-remove" @click="removeSupportDoc(item.fileid)"></i>
            </div>
          </div>
        </div>
      </b-card>
    </modal>

    <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />
    <StatusModal :show.sync="modals.removeModal" :message="modal.remove" :title="modal.removeTitle" />
    <StatusModal :show.sync="modals.removeFailedModal" :message="modal.removeFailed" :title="modal.removeTitle" />

    <div class="row" style="padding-top: 30px; padding-bottom: 30px">
      <div class="col-lg-2">
        <base-button style="font-size: 18px" @click="getHome()" class="btn-link btn-primary">
          &lt; Return Home
        </base-button>
        <!-- <p
          style="cursor: pointer; color: #358CCB; font-size: 18px"
          @click="getHome()"
        >
          &lt; Return Home
        </p> -->
      </div>
      <div class="col-lg"></div>
      <div class="col-lg-2 text-right">
        <base-button type="primary" v-on:click="createPDF()">
          <i style="color: white; font-size: 15px; font-weight: 900" class="tim-icons icon-cloud-download-93"></i>&nbsp;
          Print</base-button>
      </div>
    </div>

    <modal :show.sync="modals.disputee" class="modal-eprf" centered>
      <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
        header="REASON FOR DISPUTE" header-bg-variant="primary" header-text-variant="white">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-11"></div>
            <div style="
                position: relative;
                top: -50px;
                right: -50px;
                height: 25px;
                width: 25px;
                background-color: #ea2127;
                border-radius: 100px;
              ">
              <i style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  color: white;
                  font-weight: 900;
                  font-size: 12px;
                " class="tim-icons icon-simple-remove" @click="closeModal()"></i>
            </div>
            <textarea type="textarea" placeholder="Reason for rejection..." v-model="reason"
              :class="{ textarea: true }"></textarea>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-lg-1">
            <div class="fileinput">
              <label style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                " for="file-upload" type="primary" class="btn">
                Upload
              </label>

              <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="file-upload" ref="file" type="file" name="..." class="valid"
                :multiple="true" aria-invalid="false" style="display: none" v-on:change="onFileChange" />
            </div>
          </div> -->

          <!-- remove button file quotation -->
          <!-- <div class="col-lg"></div> -->
          <div class="col-lg text-left">
            <!-- <div class="row">
              <p class="" style="margin-left: 80px; color: #A5A5A5">{{ quotitle.length > 30 ? quotitle.slice(0, 30) + '...'
      :
      quotitle }}</p>
              <i v-if="quotitle.length > 0" style="
                    color: #FF0000;
                    font-weight: 900;
                    font-size: 20px;
                    margin-left: 10px;
                    margin-top: 20px;
                  " class="tim-icons icon-simple-remove" @click="modals.uploaddoc = false"></i>
            </div> -->
          </div>
          <div class="col-lg-4 text-right">
            <base-button :disabled="reason === ''" type="primary" v-on:click="getDecline()">Submit</base-button>
          </div>
        </div>
      </b-card>
    </modal>

    <div v-if="showOverlay" class="overlay">
      <div class="overlay-content text-center">
        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-4">
            <div style="
                height: 250px;
                width: 250px;
                padding: 15px;
                background-color: #32c671;
                border-radius: 300px;
                border: none;
                display: flex;
                justify-content: center;
                align-items: center;
              ">
              <i style="color: white; font-size: 150px; font-weight: 900" class="tim-icons icon-check-2"></i>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>

        <p style="font-size: 30px; font-weight: 600; color: #32c671">
          JOB REQUEST SUCCESSFULLY COMPLETED
        </p>
        <p style="font-size: 25px; color: #a2a2a2">
          Our Customer Relations Officer will be in touch with you within 24
          hours
        </p>
        <!-- <base-button type="warning" v-on:click="validate()">View</base-button> -->
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <card style="
            box-shadow: none;
            color: #A5A5A5;
            padding: 0px 10px 30px 0px;
            height: 630px;
            background-color: white;
          ">
          <p style="
              padding-left: 30px;
              color: #358CCB;
              font-size: 24px;
              font-weight: 300;
            ">
            JOB DETAILS
          </p>
          <div class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
            <p class="new-title">Job Reference No.</p>
            <p class="subtitle">{{ this.jobno }}</p>

            <p class="new-title">Collection Date</p>
            <p class="subtitle">{{ this.arrival }}</p>

            <p class="new-title">Company Name</p>
            <p class="subtitle">{{ this.companyname }}</p>

            <p class="new-title">Company Address</p>
            <p class="subtitle">
              {{ this.companyaddress }}
            </p>
            <br />

            <p class="new-title">Phone No. / Fax no.</p>
            <p class="subtitle">{{ this.companyphoneno }} / {{ this.companyfaxno }}</p>

            <p class="new-title">PIC Full Name</p>
            <p class="subtitle">{{ this.picname }}</p>

            <p class="new-title">PIC Phone No. / Fax No.</p>
            <p class="subtitle">{{ this.picphoneno }} / {{ this.picfaxno }}</p>

            <p class="new-title">PIC Email</p>
            <p class="subtitle">{{ this.picemail }}</p>
          </div>
        </card>
      </div>
      <div class="col-lg-8">
        <card style="
            box-shadow: none;
            padding: 0px 0px 30px 0px;
            height: 630px;
            color: #A5A5A5;
            background-color: white;
          ">
          <div class="row" style="display: flex">
            <p style="
                color: #358CCB;
                padding-left: 30px;
                font-size: 24px;
                font-weight: 300;
              ">
              QUOTATION
            </p>
          </div>
          <div class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
            <p class="new-title">Subject Line</p>
            <p class="sub-title" style="margin-bottom: 20px">
              {{ this.title }}
            </p>

            <div id="tableku" v-if="this.load == false">
              <el-table :data="tableDatas" :header-cell-style="{
      background: '#358DCC',
      border: 'transparent',
      'font-size': '14px',
      'font-weight': '400',
      color: '#FFFFFF',
    }" :cell-style="{ fontColor: '#707070' }" :row-class-name="tablerowclassname" style="color: #707070">
                <el-table-column label="NO." width="50" align="center">
                  <div slot-scope="scope">
                    <p style="color: #707070" v-if="scope.row.description != 'GRAND TOTAL'">
                      {{ scope.$index + 1 }}
                    </p>
                  </div>
                </el-table-column>

                <el-table-column :min-width="200" prop="description" label="DESCRIPTION">
                  <p slot-scope="scope" style="color: #A5A5A5">{{ scope.row.description }}</p>

                  <div v-if="scope.$index !== tableDatas.length - 1" slot-scope="scope">
                    Waste Type: {{ scope.row.wastetype }} <br />
                    Transportation Rate: RM{{ scope.row.transportrate }} <br />

                  </div>  <div v-else-if="scope.$index === tableDatas.length - 1" slot-scope="scope">
                    GRAND TOTAL
                  </div>
                </el-table-column>

                <el-table-column :min-width="150" align="center" prop="rate" label="RATE (RM)">
                </el-table-column>

                <el-table-column :min-width="150" align="center" prop="estamt" label="EST. AMOUNT">
                </el-table-column>
                <el-table-column :min-width="200" align="center" prop="amount" label="AMOUNT (RM)">
                </el-table-column>
              </el-table>
            </div>

            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Delivery Term</p>
                  <p class="sub-title">{{ this.deliveryterm }} Days</p>

                </div>
                <div class="col-lg">
                  <p class="new-title">Payment Term</p>
                  <p class="sub-title">{{ this.paymentterm1 }} Days</p>
                </div>
                <!-- <p class="sub-title">{{ this.paymentterm2 }}</p> -->
                <div class="col-lg">

                  <p class="new-title">Validity</p>
                  <p class="sub-title">{{ this.validity }} Days</p>
                </div>

              </div>
            </div>
            <!-- future
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <p class="sub-title">{{ this.remark1 }}</p>
                </div>
              </div>
            </div> -->
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg">

                  <p class="new-title">Remarks</p>
                  <p class="sub-title">{{ this.remark1 }}</p>
                </div>

              </div>
            </div>
            <!-- <p class="sub-title">{{ this.remark2 }}</p> -->
            <!-- <p class="sub-title">{{ this.remark3 }}</p> -->
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-lg"></div>
      <div class="col-lg-3 text-right">
        <base-button type="cancel" v-on:click="disputeModal()">Dispute</base-button>&nbsp;
        <!-- getApprove() -->
        <base-button type="primary" v-on:click="modals.uploaddoc = true">Accept</base-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
// import moment, { utc } from "moment";
import swal from "sweetalert2";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import moment from "moment";
import { BCard } from "bootstrap-vue";
import util from "../../../util/util";
import { getStorage } from "../../../util/storage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import StatusModal from 'src/components/StatusModal.vue';
import { modal } from "src/components/variable.js";

export default {
  props: ["parentData"],
  components: {
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Circle8,
    BCard,
    Modal,
    StatusModal,
  },
  props: ["test1"],
  data() {
    return {
      modal: modal,
      message: "",
      btnsubmit: true,
      quo: null,
      quotitle: "",
      showOverlay: false,
      showOverlay2: false,
      allquodocname: [],

      reason: "",

      jobno: "",
      jobreferenceno: "",
      arrival: "",
      companyname: "",
      companyaddress: "",
      companyphoneno: "",
      companyfaxno: "",
      picname: "",
      picphoneno: "",
      picfaxno: "",
      picemail: "",

      shipname: "",
      imono: "",
      shiptype: "",
      grosstonnage: "",
      deadweight: "",
      operatorname: "",
      callsign: "",
      flagstate: "",
      cert: "",

      title: "QUOTATION FOR TUNAS HOLDINGS",
      deliveryterm: "7 Days",
      paymentterm1: "50% payment upon job request",
      paymentterm2: "50% balance payment upon job completion",
      validity: "30 Days",
      remark1:
        "a) Payment for completed services to be paid and made payable to ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD (AFES)",
      remark2:
        "b) All waste collected will be transported to approved prescribed premise approved by Department of Environment (DOE)",
      remark3:
        "c) All waste collection request shall be made 1 day prior to commencement of services",

      referenceno: "",

      uploadload: false,
      buttondisabled: false,

      load: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },
      temp: [],
      tableDatas: [
        {
          id: "1",
          description: "SW 202 - Waste Catalysts",
          rate: "2.00",
          estamt: "10",
          amount: "20",
        },
        {
          id: "1",
          description: "SW 202 - Waste Catalysts",
          rate: "2.00",
          estamt: "10",
          amount: "20",
        },
        {
          id: "1",
          description: "SW 202 - Waste Catalysts",
          rate: "2.00",
          estamt: "10",
          amount: "20",
        },
        {
          id: "1",
          description: "SW 202 - Waste Catalysts",
          rate: "2.00",
          estamt: "10",
          amount: "20",
        },
        {
          id: "1",
          description: "GRAND TOTAL",
          rate: "",
          estamt: "",
          amount: "120",
        },
      ],

      modals: {
        submit: false,
        disputee: false,
        uploaddoc: false,
        successModal: false,
        removeModal: false,
        removeFailedModal: false,
      },
      submit: false,

      //pdf
      companynamepdf: "",
      refno: "",
      date: "",
      currentpage: "",
      totalpage: "",
      companyaddresspdf: "",
      companyphonenopdf: "",
      companyemailpdf: "",
      attention: "",
      subject: "",

      deliverypdf: "",
      paymentpdf: "",
      validitypdf: "",
      remarkspdf: "",

      pic1pdf: "",
      pic1nopdf: "",
      pic2pdf: "",
      pic2nopdf: "",
      gambarsign: "",


      pdftable: [{ no: 0, desc: "", rate: "", estamt: "", amt: "" }],
    };
  },
  created() {
    this.getPDF();
  },
  mounted() {
    this.jobno = this.$route.params.jobnum;
    this.getDatas();
    this.getData();
  },
  computed: {
    cansubmit() {
      return this.allquodocname.length === 0;
    }
  },
  methods: {
    createPDF() {
      // this.getPDF();
      this.duration = this.convertDays(this.validity);
      let doc = jsPDF({
        orientation: "potrait",
      });

      const logo = new Image();
      logo.src = require("@/assets/img/afesnew.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };

      // ni sign berbeza
      const sign = new Image();
      let imageUrl;
      var signphoto;

      if (this.gambarsign != null) {
        imageUrl = this.gambarsign;
        if (imageUrl.toLowerCase().endsWith('.png')) {
          sign.src = imageUrl;
        } else {
          sign.src = require('@/assets/img/Corrupted_Image.png');
        }
      } else {
        sign.src = require('@/assets/img/No_Available_Image.png');
      }

      // sign.src = signphoto;
      sign.onload = () => {
        this.options = Object.assign({}, this.options, {
          sign: {
            sign,
          },
        });
      };

      const data = this.pdftable;

      const columns = [
        "No.",
        "\t\t\t\t\t\t\tDescription",
        "Unit Price (RM)",
        "Quantity",
      ];

      const rows = data.map((obj) => [
        obj.no,
        obj.desc,
        obj.rate,
        obj.estamt,
        obj.amt,
      ]);

      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 75,
        5,
        50,
        18.75
      );

      doc.setFontSize(21);
      doc.setFontStyle("bold");
      doc.text("QUOTATION", 15, 25);
      doc.setFontSize(11);

      doc.setLineWidth(0.3);
      doc.line(10, 40, doc.internal.pageSize.getWidth() - 10, 40);

      doc.setFontStyle("bold");

      doc.text(this.companynamepdf, 15, 55);

      doc.setFontStyle("normal");

      var companyAddress = this.companyaddresspdf;
      var maxCharactersPerLine = 25;

      function splitTextIntoLines(text, maxLength) {
        var lines = [];
        while (text.length > maxLength) {
          var line = text.substring(0, maxLength);
          var lastSpace = line.lastIndexOf(" ");
          if (lastSpace !== -1) {
            lines.push(line.substring(0, lastSpace));
            text = text.substring(lastSpace + 1);
          } else {
            lines.push(line);
            text = text.substring(maxLength);
          }
        }
        lines.push(text);
        return lines;
      }

      var addressLines = splitTextIntoLines(
        companyAddress,
        maxCharactersPerLine
      );

      for (var i = 0; i < addressLines.length; i++) {
        var yPos = 60 + i * 5;
        doc.text(addressLines[i], 15, yPos);
      }

      doc.setFontStyle("bold");
      doc.text("Ref No.", 130, 55);
      doc.text("Date", 130, 60);
      doc.setFontStyle("normal");

      doc.text(":", 150, 55);
      doc.text(":", 150, 60);

      doc.text(this.jobno, 152, 55);
      doc.text(moment().format("DD-MM-YYYY"), 152, 60);

      doc.text("Tel No. : " + this.pic1nopdf, 15, 80);

      // doc.text("Email : -", 130, 80);
      doc.text("Email : " + this.pic1emailpdf, 130, 80);
      // doc.text(this.companyemailpdf, 85, 80);

      doc.setFontStyle("bold");

      doc.text("Attention", 15, 90);
      doc.text("Subject", 15, 95);

      doc.text(":", 35, 90);
      doc.text(":", 35, 95);

      doc.text(this.pic1pdf, 40, 90);
      doc.text(this.subject, 40, 95);

      doc.setFontStyle("normal");

      doc.text("Dear Sir/Madam,", 15, 105);
      doc.text(
        "We appreciate this opportunity to offer you our quotation as follows:",
        15,
        115
      );

      const table = doc.autoTable({
        head: [columns],
        columnStyles: {
          0: {
            halign: "center",
            cellWidth: 10,
          },
          1: {
            // columnWidth: 100,
          },
          2: {
            halign: "center",
            cellWidth: 30,
          },
          3: {
            halign: "center",
            cellWidth: 20,
          },
        },
        styles: {
          lineWidth: 0.1, // Set the border line width
          lineColor: [0, 0, 0], // Set the border color
        },
        theme: "plain",
        body: rows,
        startY: 120,
      });

      // let deliveryTermsTextPositionY = table.autoTable.previous.finalY + 10;

      // if (deliveryTermsTextPositionY > doc.internal.pageSize.getHeight() - 20) {
      //   doc.addPage();
      //   deliveryTermsTextPositionY = 20;
      // }

      const tableHeight = table.autoTable.previous.finalY;

      doc.text("Terms & Conditions", 15, tableHeight + 10);
      doc.text("Terms of Delivery", 15, tableHeight + 15);
      doc.text("Terms of Payment", 15, tableHeight + 20);
      doc.text("Validity", 15, tableHeight + 25);
      doc.text("Remarks", 15, tableHeight + 30);

      // doc.text(":", 55, tableHeight + 10);
      doc.text(":", 55, tableHeight + 15);
      doc.text(":", 55, tableHeight + 20);
      doc.text(":", 55, tableHeight + 25);
      doc.text(": ", 55, tableHeight + 30);

      doc.text(
        "a) Payment for completed services to be paid and made payable to",
        60,
        tableHeight + 30
      );
      doc.setFontStyle("bold");

      doc.text(
        "ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD.",
        60,
        tableHeight + 35
      );
      doc.setFontStyle("normal");
      doc.text(
        "b) All price(s) quoted is inclusive of Sales and Services Tax (SST), customs",
        60,
        tableHeight + 40
      );
      doc.text(
        "clerance or taxes and customs agent fees (if any).",
        60,
        tableHeight + 45
      );
      doc.text(
        "c) The invoiced quantity will be in accordance to the actual quantity",
        60,
        tableHeight + 50
      );
      doc.text(
        "collected and recorded in weigh bridge weight chit.",
        60,
        tableHeight + 55
      );
      // doc.text(
      //   "d)" + this.remark1,
      //   60,
      //   tableHeight + 60
      // );

      const ddate = "2024-06-21T08:09:16.236226Z";
      const validity = this.validity + " days";
      console.log(validity);
      // Parse the date using Moment.js
      const parsedDate = moment(ddate);

      // Add the validity period to the parsed date
      const endDate = parsedDate.clone().add(moment.duration(validity));

      // Calculate the difference in years, months, and days
      const diff = moment.duration(endDate.diff(parsedDate));
      const years = diff.years();
      const months = diff.months();
      const days = diff.days();

      // Format the result into a human-readable string
      let readableString = "";

      if (years > 0) {
        readableString += `${years} year${years > 1 ? "s" : ""}`;
      }

      if (months > 0) {
        if (readableString.length > 0) readableString += " ";
        readableString += `${months} month${months > 1 ? "s" : ""}`;
      }

      if (days > 0) {
        if (readableString.length > 0) readableString += " ";
        readableString += `${days} day${days > 1 ? "s" : ""}`;
      }

      readableString += ` (${parsedDate.format(
        "YYYY-MM-DD"
      )} - ${endDate.format("YYYY-MM-DD")})`;

      console.log(readableString);

      doc.text(
        this.deliveryterm + " " + this.deliverytermunit,
        60,
        tableHeight + 15
      );
      doc.text(this.paymentterm + " Days", 60, tableHeight + 20);
      doc.text(this.duration + " " + this.durationString, 60, tableHeight + 25); //kena kira kat sini
      var text = this.remark1;
      var x = 60;
      var y = tableHeight + 60;

      var lines = doc.splitTextToSize(
        text,
        doc.internal.pageSize.width - x * 1.3
      );

      if (this.remark1 != "" && this.remark1 != null) {
        doc.text("d) " + lines[0], x, y);
      }
      for (var i = 1; i < lines.length; i++) {
        if (y + 50 > doc.internal.pageSize.getHeight() - 20) {
          doc.addPage();
          y = 25;
        }
        doc.text(lines[i], x, y + 5);
        y += 5;
      }

      // let nextContentYPosition = table.autoTable.previous.finalY + y;

      // if (nextContentYPosition > doc.internal.pageSize.getHeight() - 20) {
      //   doc.addPage();
      //   nextContentYPosition = 20;
      // }

      var finalYOfText = y;

      doc.text(
        "If you agree with the quotation, please sign in below and send/email it to us as attached as soon as",
        15,
        finalYOfText + 10
      );

      doc.text("possible for further arrangement.", 15, finalYOfText + 15);
      doc.text(
        "Should you need any clarification, please contact " +
        this.pic1pdf +
        " at " +
        this.pic1nopdf,
        15,
        finalYOfText + 20
      );
      // doc.text(this.picname, 15, finalYOfText + 35);

      // doc.text("at", 95, finalYOfText + 35);

      // doc.text(this.picphoneno, 105, finalYOfText + 35);
      doc.setFontStyle("bold");

      doc.text(
        "for ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD",
        15,
        finalYOfText + 30
      );
      doc.setFontStyle("normal");

      doc.text(
        "Previously known as DRB-HICOM ENVIRONMENTAL SERVICES SDN BHD",
        15,
        finalYOfText + 35
      );

      doc.setFontStyle("bold");

      doc.addImage(
        sign,
        "PNG",
        doc.internal.pageSize.getWidth() - 195,
        finalYOfText + 40,
        80,
        40
      );

      // doc.text("NAZIRA MAHAYUDDIN", 15, finalYOfText + 60);

      // doc.setFontStyle("normal");
      // doc.text("Senior Manager,", 15, finalYOfText + 65);
      // doc.text("Marine Waste Management,", 15, finalYOfText + 70);
      // doc.text(
      //   "Environmental Technology & Solutions Department",
      //   15,
      //   finalYOfText + 75
      // );

      //acknowledgement start here
      doc.addPage();
      doc.text("TO:", 15, 25);
      doc.setFontStyle("bold");
      doc.text("ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD", 15, 30);
      doc.text("MARINE WASTE MANAGEMENT, PORT RECEPTION FACILITIES", 15, 35);

      doc.setFontStyle("normal");
      doc.text("Attention : " + this.pic1pdf, 15, 45);
      // doc.text("Email : " + this.pic1nopdf, 100, 45);
      doc.text("Email : " + this.pic1emailpdf, 100, 45);

      doc.setFontStyle("bold");
      doc.text("ACKNOWLEDGEMENT / ACCEPTANCE OF OFFER", 60, 55);

      doc.setFontStyle("normal");
      doc.text(
        "I, .................................................................................................. as ................................................................",
        15,
        65
      );

      doc.setFontStyle("italic");

      doc.text("(Name)", 55, 70);
      doc.text("(Designation)", 145, 70);

      doc.setFontStyle("normal");

      doc.text(
        "Agreed to the quotation stated in the above mentioned letter ref no. " +
        this.jobno,
        15,
        80
      );
      doc.text(
        "dated " +
        moment().format("DD MMMM YYYY") +
        " and all terms and condition as mentioned.",
        15,
        85
      );

      doc.text("Thank you.", 15, 95);

      doc.text("Company Name", 15, 105);
      doc.text(
        ": ...............................................................................................................................",
        60,
        105
      );

      doc.text("Company Address", 15, 115);
      doc.text(
        ": ...............................................................................................................................",
        60,
        115
      );
      doc.text(
        ": ...............................................................................................................................",
        60,
        120
      );
      doc.text(
        ": ...............................................................................................................................",
        60,
        125
      );

      doc.text("Contact Person", 15, 135);
      doc.text(
        ": ...............................................................................................................................",
        60,
        135
      );

      doc.text("Designation", 15, 145);
      doc.text(
        ": ...............................................................................................................................",
        60,
        145
      );

      doc.text("Tel. No.", 15, 155);
      doc.text(
        ": ...............................................................................................................................",
        60,
        155
      );

      doc.text("Mobile No.", 15, 165);
      doc.text(
        ": ...............................................................................................................................",
        60,
        165
      );
      doc.text("Email Address", 15, 185);
      doc.text(
        ": ...............................................................................................................................",
        60,
        185
      );

      doc.text("Service to commence", 15, 195);
      doc.text(
        ": ...............................................................................................................................",
        60,
        195
      );

      const xx = 70;
      const xxx = 130;

      const yy = 199;
      const yyy = 209;

      const width = 8;
      const height = 8;

      // Draw the box
      doc.rect(xx, yy, width, height);

      doc.rect(xxx, yy, width, height);

      doc.rect(xx, yyy, width, height);

      doc.rect(xxx, yyy, width, height);

      doc.text("Contract Preferred", 15, 205);
      doc.text(":", 60, 205);
      doc.text("One off job", 80, 205);
      doc.text("*Two (2) years", 140, 205);

      doc.text("*One (1) year", 80, 215);
      doc.text("*Others, please specify", 140, 215);

      doc.setFontStyle("italic");
      doc.text(
        "I/We declare that the data provided is correct and accordingly. I/We also declare that all",
        15,
        225
      );
      doc.text(
        "individuals who are subject of any personal data provided therein have consented to my/our",
        15,
        230
      );
      doc.text(
        'disclosure of the personal data to Alam Flora Environmental Solutions Sdn Bhd ("AFES")',
        15,
        235
      );
      doc.text(
        "(Previously known as DRB-HICOM Environmental Services Sdn Bhd (“DHES”)) and the use",
        15,
        240
      );
      doc.text(
        "by AFES of the personal data in accordance with the policy on personal data attached herein.",
        15,
        245
      );

      doc.text(
        ".......................................................",
        15,
        265
      );
      doc.text("(Signature & Company's Stamp)", 16, 270);

      doc.text(".................................................", 120, 265);
      doc.text("(Date)", 140, 270);

      // doc.text("Created by " + this.pic1pdf, 15, finalYOfText + 80);
      if (this.jobno.startsWith("V")) {
        doc.save("ANF Quotation.pdf");
      } else if (this.jobno.startsWith("L")) {
        doc.save("WCO Quotation.pdf");
      } else {
        doc.save("Quotation.pdf");
      }

      console.log("pdf createdd");
    },
    // createPDF() {
    //   let doc = jsPDF({
    //     orientation: "potrait",
    //   });

    //   const logo = new Image();
    //   logo.src = require("@/assets/img/afes.png");
    //   logo.onload = () => {
    //     this.options = Object.assign({}, this.options, {
    //       logo: {
    //         logo,
    //       },
    //     });
    //   };

    //   const data = this.pdftable;

    //   const columns = [
    //     "No.",
    //     "Description",
    //     "Rate (RM/KG)",
    //     "Est. Amount (KG)",
    //     "Amount (KG)",
    //   ];

    //   const rows = data.map((obj) => [
    //     obj.no,
    //     obj.desc,
    //     obj.rate,
    //     obj.estamt,
    //     obj.amt,
    //   ]);

    //   doc.addImage(
    //     logo,
    //     "PNG",
    //     doc.internal.pageSize.getWidth() - 50,
    //     10,
    //     40,
    //     40
    //   );

    //   doc.setFontSize(12);
    //   doc.text("QUOTATION", 25, 40);

    //   doc.setLineWidth(0.3);
    //   doc.line(10, 50, doc.internal.pageSize.getWidth() - 10, 50);

    //   doc.text(this.companynamepdf, 15, 55);

    //   var companyAddress = this.companyaddresspdf;
    //   var maxCharactersPerLine = 25;

    //   function splitTextIntoLines(text, maxLength) {
    //     var lines = [];
    //     while (text.length > maxLength) {
    //       var line = text.substring(0, maxLength);
    //       var lastSpace = line.lastIndexOf(" ");
    //       if (lastSpace !== -1) {
    //         lines.push(line.substring(0, lastSpace));
    //         text = text.substring(lastSpace + 1);
    //       } else {
    //         lines.push(line);
    //         text = text.substring(maxLength);
    //       }
    //     }
    //     lines.push(text);
    //     return lines;
    //   }

    //   var addressLines = splitTextIntoLines(
    //     companyAddress,
    //     maxCharactersPerLine
    //   );

    //   for (var i = 0; i < addressLines.length; i++) {
    //     var yPos = 60 + i * 5;
    //     doc.text(addressLines[i], 15, yPos);
    //   }

    //   doc.text("Ref No.", 130, 55);
    //   doc.text("Date", 130, 60);

    //   doc.text(":", 150, 55);
    //   doc.text(":", 150, 60);

    //   doc.text(this.jobno, 152, 55);
    //   doc.text(this.arrival, 152, 60);

    //   doc.text("Tel :", 15, 80);
    //   doc.text(this.companyphoneno, 25, 80);

    //   doc.text("Email : -", 70, 80);
    //   // doc.text(this.companyemailpdf, 85, 80);

    //   doc.text("Attention", 15, 90);
    //   doc.text("Subject", 15, 95);

    //   doc.text(":", 35, 90);
    //   doc.text(":", 35, 95);

    //   doc.text(this.companyname, 40, 90);
    //   doc.text(this.title, 40, 95);

    //   doc.text("Dear Sir/Madam,", 15, 105);
    //   doc.text(
    //     "We appreciate this opportunity to offer you our quotation as follows:",
    //     15,
    //     115
    //   );

    //   const table = doc.autoTable({
    //     head: [columns],
    //     body: rows,
    //     startY: 120,
    //   });

    //   let deliveryTermsTextPositionY = table.autoTable.previous.finalY + 10;

    //   if (deliveryTermsTextPositionY > doc.internal.pageSize.getHeight() - 20) {
    //     doc.addPage();
    //     deliveryTermsTextPositionY = 20;
    //   }

    //   let nextContentYPosition = deliveryTermsTextPositionY + 10;

    //   if (nextContentYPosition > doc.internal.pageSize.getHeight() - 20) {
    //     doc.addPage();
    //     nextContentYPosition = 20;
    //   }

    //   doc.text("Delivery Terms", 15, table.autoTable.previous.finalY + 10);
    //   doc.text("Terms of Payment", 15, table.autoTable.previous.finalY + 15);
    //   doc.text("Validity", 15, table.autoTable.previous.finalY + 20);
    //   doc.text("Remarks", 15, table.autoTable.previous.finalY + 25);

    //   doc.text(":", 55, table.autoTable.previous.finalY + 10);
    //   doc.text(":", 55, table.autoTable.previous.finalY + 15);
    //   doc.text(":", 55, table.autoTable.previous.finalY + 20);
    //   doc.text(":", 55, table.autoTable.previous.finalY + 25);

    //   doc.text(
    //     this.deliveryterm + " Days",
    //     60,
    //     table.autoTable.previous.finalY + 10
    //   );
    //   doc.text(
    //     this.paymentterm1 + " Days",
    //     60,
    //     table.autoTable.previous.finalY + 15
    //   );
    //   doc.text(
    //     this.validity + " Days",
    //     60,
    //     table.autoTable.previous.finalY + 20
    //   );
    //   var text = this.remark1;
    //   var x = 60;
    //   var y = table.autoTable.previous.finalY + 25;

    //   var lines = doc.splitTextToSize(
    //     text,
    //     doc.internal.pageSize.width - x * 2
    //   );

    //   for (var i = 0; i < lines.length; i++) {
    //     if (y + 10 > doc.internal.pageSize.height) {
    //       doc.addPage();
    //       y = 25;
    //     }
    //     doc.text(lines[i], x, y);
    //     y += 5;
    //   }

    //   var finalYOfText = y;

    //   doc.text(
    //     "If you agree with the quotation, please fill in the Acknowledgement from as attached as soon as",
    //     15,
    //     finalYOfText + 20
    //   );

    //   doc.text("possible for further arrangement.", 15, finalYOfText + 25);
    //   doc.text(
    //     "Should you need any clarification, please contact:",
    //     15,
    //     finalYOfText + 30
    //   );
    //   doc.text(this.picname, 15, finalYOfText + 35);

    //   doc.text("at", 95, finalYOfText + 35);

    //   doc.text(this.picphoneno, 105, finalYOfText + 35);

    //   doc.text(
    //     "for ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD",
    //     15,
    //     finalYOfText + 55
    //   );
    //   doc.text(
    //     "Previously known as DRB-HICOM ENVIRONMENTAL SERVICES SDN BHD",
    //     15,
    //     finalYOfText + 60
    //   );
    //   // doc.text("Created by " + this.pic1pdf, 15, finalYOfText + 80);

    //   doc.save("WCO Quotation.pdf");

    //   console.log("pdf created");
    // },
    disputeModal() {
      this.modals.disputee = true;
    },
    closeModal() {
      this.modals.disputee = false;
      this.$router.push("/Land/Request")
    },
    submitData() {
      this.modals.submit = true;
      setTimeout(() => {
        this.modals.submit = false;
        this.$router.push("/Land/Request");
        // this.$router.push("/Land/Request")
      }, 1500);

      this.submit = true;
    },

    getData() {
      this.load = true;
      this.tableDatas = [];
      this.allquodocname = [],

        this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
          if (!res.error) {
            let response = res.message;
            let amountt = 0;
            console.log("quote table", response);

            this.title = response.quotation.subject_line.toUpperCase();

            this.deliveryterm = response.quotation.delivery_term;
            this.paymentterm1 = response.quotation.payment_term;
            this.validity = response.quotation.validity;
            this.remark1 = response.quotation.remarks;

            let ratee;
            let estamtt;
            let amt;

            let formatter = new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });

            for (var i = 0; i < response.waste_detail.length; i++) {
              ratee = response.waste_detail[i].rate;
              estamtt = response.waste_detail[i].estimated_quantity;
              amt = ratee * estamtt;
              let obj = {
                id: "1",
                wastetype: response.waste_detail[i].waste_type_name,
                wastesubtype: response.waste_detail[i].waste_type_sub_name,
                transportrate: formatter.format(response.waste_detail[i].transport_rate),
                description:
                  response.waste_detail[i].waste_type_name +
                  "\n" +
                  response.waste_detail[i].waste_type_sub_name + "\n" + "Transportation rate: RM" + response.waste_detail[i].transport_rate,
                rate: formatter.format(ratee),
                estamt: formatter.format(estamtt) + " " + response.waste_detail[i].estimated_quantity_unit,
                amount: formatter.format(amt),
              };
              amountt += amt;
              amountt += response.waste_detail[i].transport_rate;
              this.tableDatas.push(obj);
            }

            //get quo docs
            if (response.quotation != null)
              if (response.quotation.quotation_support_document != null) {
                for (var i = 0; i < response.quotation.quotation_support_document.length; i++) {
                  let obj = {
                    filename: response.quotation.quotation_support_document[i].filename,
                    fileurl: response.quotation.quotation_support_document[i].url,
                    fileid: response.quotation.quotation_support_document[i].quotation_support_document_id,
                  };
                  this.allquodocname.push(obj);
                }

                console.log('all docs', this.allquodocname);
              }

            let obj2 = {
              id: "1",
              description: "GRAND TOTAL",
              rate: "",
              estamt: "",
              amount: "RM " + formatter.format(amountt),
            };
            this.tableDatas.push(obj2);
            this.temp.push(obj2);

          }
          this.load = false;
        });

    },

    getApprove() {
      let obj = {
        remarks: this.reason,
      };

      this.$http
        .put(
          ":10001/api/v1/incoming/" +
          this.jobreferenceno +
          "/quotation/approve",
          obj
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log("quote approve", response);
            swal({
              title: `Success!`,
              text: 'Approve success.',
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                //pastu kena ke mana
                this.submitData();

                this.$router.push("/Land/Request");
              }
            });
          } else {
            console.log("quote not approve", response);
          }
        }).catch((err) => {
          swal({
            title: `Error!`,
            text: 'Approve failed.',
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    getDecline() {
      let obj = {
        remarks: this.reason,
      };
      console.log('object', obj);

      this.$http
        .put(
          ":10001/api/v1/incoming/" + this.jobreferenceno + "/quotation/reject",
          obj
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log("quote reject", response);
            swal({
              title: `Success!`,
              text: 'Dispute success.',
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                //pastu kena ke mana
                this.$router.push("/Land/Request");
              }
            });
            // this.closeModal();
          } else {
            console.log("quote not reject", response);
          }
        }).catch((err) => {
          swal({
            title: `Error!`,
            text: 'Dispute failed.',
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },

    getHome() {
      this.$router.push("/Land/Request");
    },

    removeSupportDoc(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" +
              this.jobno +
              "/quotation/" +
              id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getData();
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.removeFailedModal = true;
              }
            });
        }
      });
    },

    onFileChangeQuo(event) {
      this.uploadload = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.quotitle = filesArray.map(file => file.name).join(', ');

        const uploadPromises = [];

        this.uploadload = true;
        this.buttondisabled = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("document", input);

          const uploadPromise = this.$http.post(
            ":10001/api/v1/incoming/" + this.jobno + "/quotation/quotation-document",
            formData,
            {
              headers: {
                Authorization: `Bearer ${getStorage("token")}`,
                "Content-Type": "multipart/form-data",
              },
            }
          ).then((res) => {
            if (!res.error) {
              let response = res.message;
              setTimeout(() => {
                this.getData();
              }, 1000);
              this.message = response;
            } else {
              console.log("data tak masuk");
              swal({
                title: "Data Error!",
                text: `${res.message}`,
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
            }
          }).catch((error) => {
            console.error("Upload failed:", error);
          });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises).then(() => {
          this.modals.successModal = true;
          this.btnsubmit = false;
          t.value = "";

        }).catch((error) => {
          console.error("One or more uploads failed:", error);
        }).finally(() => {
          this.uploadload = false;
          this.buttondisabled = false;
        });
      } else {
        this.quotitle = "";
      }
    },

    // onFileChangeQuo(event) {
    //   this.upload = true;
    //   this.quotitle = this.$refs.quo.files[0].name;

    //   let input = this.$refs.quo.files[0];
    //   const formData = new FormData();
    //   formData.append("document", input);

    //   this.uploadload = true;
    //   this.buttondisabled = true;
    //   this.$http
    //     .post(
    //       ":10001/api/v1/incoming/" +
    //       this.jobno +
    //       "/quotation/quotation-document",
    //       formData,
    //       {
    //         headers: {
    //           Authorization: `Bearer ${getStorage("token")}`,
    //           "Content-Type": "multipart/form-data",
    //         },
    //       }
    //     )
    //     .then((res) => {
    //       if (!res.error) {
    //         let response = res.message;
    //         setTimeout(() => {
    //           this.getData();
    //         }, 1000);

    //         this.modals.successModal = true
    //         this.message = response
    //         this.btnsubmit = false
    //         this.uploadload = false;

    //       } else {
    //         console.log("data tak masuk");
    //         swal({
    //           title: "Data Error!",
    //           text: `${res.message}`,
    //           type: "warning",
    //           confirmButtonClass: "btn btn-success btn-fill",
    //           confirmButtonText: "Okay",
    //           buttonsStyling: false,
    //         });

    //         this.uploadload = false;

    //       }
    //     });
    //   this.buttondisabled = false;
    // },

    onFileChange2(event) {
      this.upload = true;
      this.quotitle = this.$refs.quo.files[0].name;

      let input = this.$refs.quo.files[0];
      const formData = new FormData();
      formData.append("document", input);

      this.uploadload = true;
      this.buttondisabled = true;
      // {{port}}/api/v1/incoming/{{new_reference_no}}/quotation/quotation-document
      this.$http
        .post(
          ":10001/api/v1/incoming/" +
          this.jobno +
          "/quotation/quotation-document",
          formData,
          {
            headers: {
              Authorization: `Bearer ${getStorage("token")}`,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            setTimeout(() => {
              this.getData();
            }, 1000);

            this.modals.successModal = true
            this.message = response
            this.btnsubmit = false
            this.uploadload = false;

          } else {
            console.log("data tak masuk");
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });

            this.uploadload = false;

          }
        });
      this.buttondisabled = false;
    },
    onFileChange(event) {
      this.upload = true;
      const t = event.target;
      // if (t.files.length > 0) {
      //   for (let i = 0; i < t.files.length; i++) {
      //     this.selectedFileName = t.files[i].name;
      //     this.allfilename.push(this.selectedFileName);
      //   }
      // } else {
      //   this.selectedFileName = "";
      // }

      this.document = t.files.length;

      var input;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.file.files[i];
          const formData = new FormData();
          formData.append("document", input);
          this.quotitle = t.files[i].name;

          this.docs = formData;

          this.uploadload = true;
          this.buttondisabled = true;

          this.$http
            .post(
              ":10001/api/v1/incoming/" +
              this.jobno +
              "/upload/dispute-waste-job",
              this.docs,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log("data masuk", response);

                this.modals.successModal = true
                this.message = response
                this.btnsubmit = false
                this.uploadload = false;

                // swal({
                //   title: "Successful!",
                //   text: res.message,
                //   type: "success",
                //   confirmButtonClass: "btn btn-success btn-fill",
                //   confirmButtonText: "Okay",
                //   buttonsStyling: false,
                // });
              } else {
                console.log("data tak masuk");
                swal({
                  title: "Data Error!",
                  text: `${res.message}`,
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false,
                });

                this.uploadload = false;

              }
            });
          this.buttondisabled = false;
        }
      }
    },

    tablerowclassname({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "even-row";
      } else {
        return "odd-row";
      }
    },
    getDatas() {
      this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log("job list  nooo", response);

          this.jobreferenceno = response.reference_number;
          this.arrival = moment(response.arrival_eta).format("DD-MM-YYYY");
          this.companyname = response.company.company_name;
          this.companyaddress = response.company.company_address;
          this.companyphoneno = response.company.company_phone_number == '' || response.company.company_phone_number == null ? "N/A" : response.company.company_phone_number;
          this.companyfaxno = response.company.company_fax_number == '' || response.company.company_fax_number == null ? "N/A" : response.company.company_fax_number;

          this.picname = response.pic.user_name;
          this.picphoneno = response.pic.user_phone_number;
          this.picfaxno = response.pic.user_fax_number == '' || response.pic.user_fax_number == null ? "N/A" : response.pic.user_fax_number;

          this.picemail = response.pic.user_email;
        }
      });
    },
    convertDays(totalDays) {
      const daysInYear = 365;
      const daysInWeek = 7;

      const years = Math.floor(totalDays / daysInYear);
      const weeks = Math.floor((totalDays % daysInYear) / daysInWeek);
      const days = totalDays % daysInWeek;

      let result = "";
      if (years > 0) result += `${years} years, `;
      if (weeks > 0) result += `${weeks} weeks, `;
      result += `${days} days`;

      // Remove any trailing comma and space
      return result.replace(/,\s*$/, "");
    },

    calculateDuration() {
      const parsedDate = moment(this.ddate, moment.ISO_8601, true);
      const endDate = parsedDate.clone().add(moment.duration(this.validity));

      const years = endDate.diff(parsedDate, "years");
      parsedDate.add(years, "years");

      const months = endDate.diff(parsedDate, "months");
      parsedDate.add(months, "months");

      const days = endDate.diff(parsedDate, "days");

      let readableString = "";

      if (years > 0) {
        readableString += `${years} year${years > 1 ? "s" : ""}`;
      }

      if (months > 0) {
        if (readableString.length > 0) readableString += " ";
        readableString += `${months} month${months > 1 ? "s" : ""}`;
      }

      if (days > 0) {
        if (readableString.length > 0) readableString += " ";
        readableString += `${days} day${days > 1 ? "s" : ""}`;
      }

      readableString += ` (${endDate.format("YYYY-MM-DD")} - ${moment(
        this.date
      ).format("YYYY-MM-DD")})`;

      this.durationString = readableString;

      console.log(this.durationString);
    },
    // async getPDF() {
    //   this.pdftable = [];

    //   await this.$http
    //     .get(":10001/api/v1/incoming/" + this.jobno + "/quotation/generate")
    //     .then((res) => {
    //       if (!res.error) {
    //         let response = res.message;

    //         console.log("hiuu", response);

    //         console.log("wowow", this.quotations);

    //         this.companynamepdf = response.company_name;
    //         this.refno = response.reference_number;
    //         this.date = moment(response.quotation_issued_at).format(
    //           "DD-MM-YYYY"
    //         );

    //         this.companyaddresspdf = response.company_address;
    //         this.companyphonenopdf = response.customer_phone_number;
    //         this.companyemailpdf = response.customer_email;
    //         this.attention = response.customer_name;
    //         this.subject = response.subject_line;

    //         this.deliverypdf = response.delivery_term;
    //         this.paymentpdf = response.payment_term;
    //         this.validitypdf = response.validy;
    //         this.remarkspdf = response.remarks;

    //         this.pic1pdf = response.afes_pic_name;
    //         this.pic1nopdf = response.afes_pic_phone_number;
    //         this.pic1emailpdf = response.afes_pic_email;
    //         this.pic2pdf = "";
    //         this.pic2nopdf = "";

    //         let ratee;
    //         let estamtt;
    //         let amt;
    //         let amountt = 0;

    //         let formatter = new Intl.NumberFormat("en-US");

    //         for (let i = 0; i < this.quotations.length - 1; i++) {
    //           console.log(this.quotations[i].estunit.toString());
    //         }

    //         for (var i = 0; i < response.waste_detail.length; i++) {
    //           ratee = response.waste_detail[i].rate.toFixed(2);
    //           estamtt = response.waste_detail[i].estimated_quantity;
    //           amt = ratee * estamtt;
    //           let obj = {
    //             no: i + 1,
    //             desc:
    //               response.waste_detail[i].waste_type_name +
    //               "\n" +
    //               response.waste_detail[i].waste_sub_type_name,
    //             rate: formatter.format(ratee),
    //             estamt:
    //               response.waste_detail[i].estimated_quantity +
    //               // + " MT",
    //               " " +
    //               response.waste_detail[i].estimated_quantity_unit,
    //             // + this.quotations[i].estunit.toString(),
    //             amt: amt,
    //           };
    //           amountt += amt;
    //           this.pdftable.push(obj);
    //         }
    //       }
    //     });
    // },
    getPDF() {
      console.log("hoo", this.jobno);
      this.pdftable = [];
      // pdftable: [{ no: 0, desc: "", rate: "", estamt: "", amt: "" }],

      this.$http
        .get(
          ":10001/api/v1/incoming/" +
          this.$route.params.jobnum +
          "/quotation/generate"
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            console.log("hui", response);

            this.companynamepdf = response.company_name;
            this.refno = response.reference_number;
            this.date = moment(response.quotation_issued_at).format("DD-MM-YYYY");
            // currentpage: "",
            // totalpage: "",
            this.companyaddresspdf = response.company_address;
            this.companyphonenopdf = response.customer_phone_number;
            this.companyemailpdf = response.customer_email;
            this.attention = response.customer_name;
            this.subject = response.subject_line;

            this.deliverypdf = response.delivery_term;
            this.paymentpdf = response.payment_term;
            this.validitypdf = response.validy;
            this.remarkspdf = response.remarks;

            this.pic1pdf = response.afes_pic_name;
            this.pic1nopdf = response.afes_pic_phone_number;
            this.pic1emailpdf = response.afes_pic_email;
            this.pic2pdf = "";
            this.pic2nopdf = "";
            this.pic2emailpdf = "";

            this.gambarsign = response.signature_url;


            let ratee;
            let estamtt;
            let amt;
            let amountt = 0;
            let formatter = new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });

            if (response.waste_detail != null) {
              for (var i = 0; i < response.waste_detail.length; i++) {
                ratee = response.waste_detail[i].rate;
                estamtt = response.waste_detail[i].estimated_quantity;
                amt = ratee * estamtt;
                let obj = {
                  no: i + 1,
                  desc:
                    response.waste_detail[i].waste_type_name +
                    "\n" +
                    response.waste_detail[i].waste_sub_type_name + "\n" + "Transportation rate: RM" + formatter.format(response.waste_detail[i].transport_rate),
                  rate: formatter.format(ratee),
                  estamt: formatter.format(estamtt) + " " + response.waste_detail[i].estimated_quantity_unit,
                  amt: amt,
                };
                amountt += amt;
                amountt += response.waste_detail[i].transport_rate;
                this.pdftable.push(obj);
              }

              console.log('amountt', amountt);

              let obj2 = {
                no: "",
                desc: "GRAND TOTAL",
                rate: "",
                estamt: "RM " + formatter.format(amountt),
                amt: amountt,
              };
              this.pdftable.push(obj2);
            }
          }
        });
    },
    getType() { },
    validate() {
      // if(this.imagebase64 == "" || this.images.regular == null){
      //     swal({
      //         title: "Data Error!",
      //         text: "All data must be filled in.",
      //         type: "warning",
      //         confirmButtonClass: "btn btn-success btn-fill",
      //         buttonsStyling: false,
      //     });
      // } else {
      return this.$validator.validateAll().then((res) => {
        // this.$root.$emit("image", this.imagebase64);
        return res;
      });
      // }
    },
  },
};
</script>
<style scoped>
.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
  height: 20px;
}

.sub-title {
  margin-top: 0px;
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
  color: #A5A5A5 !important;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  background: transparent;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  z-index: 9999;
}

.overlay-content-2 {
  background: transparent;
  width: 600px;
  border-radius: 8px;
  text-align: center;
  z-index: 9999;
}

.scrollable {
  height: 550px;
  overflow-y: scroll;
  padding-right: 10px;
}

.textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  background-color: #ffffff;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

.textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out;
  background-color: 0.3s ease-in-out;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}
</style>
